// react
import { useCallback, useContext } from 'react';

// types
import { EntityType, Permissions } from '../@types';
import { entityTypesDefault } from '../@types/unions';

// context
import { ContextProject } from '../components/pages/Project/Project.context';

// utils
import {
	ConstructPermissionsProps,
	constructPermissions,
	filterPermissionsByVersion,
} from '../utils/permissions';

// props
export type GetPermissionsDefaultParams =
	| { template: ConstructPermissionsProps['template']; entityType?: never }
	| { entityType?: EntityType | string; template?: never };

export const usePermissions = () => {
	// context
	const { project } = useContext(ContextProject);

	const filterPermissions = useCallback(
		(permissions: Permissions): Permissions => {
			return filterPermissionsByVersion({ permissions, version: project?.version ?? '' });
		},
		[project?.version]
	);

	const getPermissionsDefault = useCallback(
		({ entityType, template }: GetPermissionsDefaultParams): Permissions => {
			let templateResolved: ConstructPermissionsProps['template'];

			if (template) {
				templateResolved = template;
			} else if (entityTypesDefault.some((type) => type === entityType)) {
				templateResolved = 'READ_WRITE';
			} else if (entityType === 'BENEFICIARY') {
				templateResolved = 'BENEFICIARY';
			} else if (entityType === 'SUPPLIER') {
				templateResolved = 'SUPPLIER';
			} else {
				templateResolved = 'READ_ONLY';
			}

			return filterPermissions(constructPermissions({ template: templateResolved }));
		},
		[filterPermissions]
	);

	return { filterPermissions, getPermissionsDefault };
};
